<div class="align-items-center d-flex justify-content-center" style="height: 100%;" [ngStyle]="{'background': background}">
  <div class="container">
    <div>
        <div class="row">
          <table class="ml-3 mb-1">
            <tbody>
              <tr>
                <td class="align-middle"><button class="flagbutton pl-1" (click)="changelanguage('sv')"><img class="flagicon" title="Svenska" alt="Svenska" src="../../../assets/Images/sweden-flag-round-icon-128.png"></button></td>
                <td class="align-middle"><button class="flagbutton pl-1" (click)="changelanguage('en')"><img class="flagicon" title="English" alt="English" src="../../../assets/Images/united-kingdom-flag-round-icon-128.png"></button></td>
              </tr>
            </tbody>
          </table>    
        </div>
    </div>
    <div id="formContent">
      
      <div name="checkindiv" *ngIf="checkInSuccess === false">
        <div class="fadeIn first pt-5">
          <div id="logoContainer">
            <img [src]="logo" id="icon" alt="Logo" />
          </div>
          <div class="row justify-content-center">
            <h4 [ngStyle]="fontStyle"> {{ 'PAGES.CHECKIN.WELCOME' | translate }}! <br><br> {{ 'PAGES.CHECKIN.PLEASE_ENTER_SSN' | translate }} <br> {{ 'PAGES.CHECKIN.NOTIFY_ARRIVAL' | translate }}</h4>
          </div>
        </div>
    
        <form (keydown.enter)="$event.preventDefault()">
          
          <div class="btn-group-vertical fadeIn second d-flex mt-5 ml-5 mr-5 mb-3" role="group">
            <input type="text" maxlength="12" id="ssn" class="text-center  mb-2" name="ssn" 
              [(ngModel)]="displaySsn"
              placeholder="{{ 'PAGES.CHECKIN.PLACEHOLDER_SSN' | translate }}" 
              readonly
              autocomplete="off">
  
            <div class="btn-group btn-group-lg">
              <button type="button" [ngStyle]="buttonStyle" class="btn mr-1 my-1" (click)="addTosSsn('1')">1</button>
              <button type="button" [ngStyle]="buttonStyle" class="btn m-1" (click)="addTosSsn('2')">2</button>
              <button type="button" [ngStyle]="buttonStyle" class="btn ml-1 my-1" (click)="addTosSsn('3')">3</button>
            </div>
            <div class="btn-group btn-group-lg">
                <button type="button" [ngStyle]="buttonStyle" class="btn mr-1 my-1" (click)="addTosSsn('4')">4</button>
                <button type="button" [ngStyle]="buttonStyle" class="btn m-1" (click)="addTosSsn('5')">5</button>
                <button type="button" [ngStyle]="buttonStyle" class="btn ml-1 my-1" (click)="addTosSsn('6')">6</button>
            </div>
            <div class="btn-group btn-group-lg">
                <button type="button" [ngStyle]="buttonStyle" class="btn mr-1 my-1" (click)="addTosSsn('7')">7</button>
                <button type="button" [ngStyle]="buttonStyle" class="btn m-1" (click)="addTosSsn('8')">8</button>
                <button type="button" [ngStyle]="buttonStyle" class="btn ml-1 my-1" (click)="addTosSsn('9')">9</button>
            </div>
            <div class="btn-group btn-group-lg">
                <button type="button" [ngStyle]="buttonStyle" class="btn mr-1 my-1" (click)="removeFromsSsn()">&lt;</button>
                <button type="button" [ngStyle]="buttonStyle" class="btn m-1" (click)="addTosSsn('0')">0</button>
                <button type="button" [ngStyle]="buttonStyle" class="btn ml-1 my-1" (click)="clearSsn()">{{ 'PAGES.CHECKIN.CLEAR' | translate }}</button>
            </div>
          </div>
  
        </form>

      </div>

      <div name="resultdiv" *ngIf="checkInSuccess === true">

        <div class="p-5" *ngIf="noAppointments === true">
          <div class="row justify-content-center">
            <h2 [ngStyle]="fontStyle" class="fadeIn first">{{ 'PAGES.CHECKIN.NO_APPOINTMENTS_MESSAGE' | translate }} </h2>
          </div>
          <div class="row justify-content-center">
            <h2 class="fadeIn second" [ngStyle]="fontStyle">{{ 'PAGES.CHECKIN.PLEASE_CONTACT_RECEPTION' | translate }}</h2>
          </div>
          <div class="row justify-content-center pt-5 fadeIn third" >
            <button type="button" [ngStyle]="buttonStyle" class="btn btn-lg btn-block " (click)="close()">{{ 'PAGES.CHECKIN.CLOSE' | translate }}</button>
          </div>
        </div>
  
        <div class="p-5" *ngIf="noAppointments === false">
          <div class="row justify-content-center fadeIn first">
            <h2 [ngStyle]="fontStyle">{{ 'PAGES.CHECKIN.HI' | translate }} {{ checkInResult.patientFirstName }}</h2>
          </div>
          <div class="row justify-content-center fadeIn first">
            <h2 [ngStyle]="fontStyle">{{ 'PAGES.CHECKIN.YOU_ARE_CHECKIN' | translate }}</h2>
          </div>
          <div class="row justify-content-center fadeIn first">
            <h2 [ngStyle]="fontStyle">{{ checkInResult.customMessage }} </h2>
          </div>
      
          <form>

            <div class="row justify-content-center p-3">
              <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
            </div>

            <div class="item fadeIn second" *ngFor="let appointment of checkInResult.appointments; let i = index">
              <div class="row">
                <textarea id="{{'treater-' + i}}" class="fadeIn second" [readonly]="true" [value]="formatAppointment(appointment)">
                </textarea>
              </div>
            </div>

          </form>

          <div class="row justify-content-center pt-5 fadeIn third" >
            <button type="button" [ngStyle]="buttonStyle" class="btn btn-lg btn-block " (click)="close()">{{ 'PAGES.CHECKIN.CLOSE' | translate }}</button>
          </div>
        </div>

      </div>

      <div id="formFooter" class="p-3">
        <h3> {{errorMessage}}</h3>
      </div>

    </div>
  </div>
</div>